import { useEffect, useLayoutEffect } from 'react';
import refreshJudgeMe from 'utils/refresh-judge-me';

const DELAY = 500;

/** Triggers refreshJudgeMe after DOM is mounted*/
const useRefreshJudgeMe = (
  deps: Parameters<typeof useLayoutEffect>[1] = []
): void => {
  // Suppress SSR warning for useLayoutEffect
  const useIsomorphicLayoutEffect =
    typeof window !== 'undefined' ? useLayoutEffect : useEffect;

  useIsomorphicLayoutEffect(() => {
    // Workaround to ensure that the widget is always loaded correctly,
    // not "beautiful" but effective
    const timeout = setTimeout(refreshJudgeMe, DELAY);
    return () => {
      clearTimeout(timeout);
    };
  }, deps);
};

export default useRefreshJudgeMe;
